import { AssetDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useQuery } from '@tanstack/react-query';

import { AWAIssuesList } from '@/awa-pages/[workspaceId]/assets/[id]/issues/list';
import { SkeletonList } from '@/awa-pages/[workspaceId]/assets/[id]/issues/skeleton-list';
import { WarningIcon } from '@/components/icons/warning';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { getAWAIssuesQueryOptions } from '@/queries/issues';

export function AWAAssetIssues({ asset }: { asset: AssetDTO }) {
  const {
    data: issuesData,
    isLoading: issuesLoading,
    isError: issuesFetchError,
  } = useQuery(getAWAIssuesQueryOptions({ assetId: asset.id, orderBy: { field: 'status', direction: 'asc' } }));

  if (issuesLoading) {
    return <SkeletonList />;
  }

  return (
    <div className="flex flex-col">
      <AWAIssuesList issues={issuesData || []} asset={asset} />

      <Dialog open={!issuesLoading && issuesFetchError && !issuesData}>
        <DialogContent className="w-[354px] rounded-md p-0 sm:w-[500px]">
          <VisuallyHidden>
            <DialogTitle>Error</DialogTitle>
          </VisuallyHidden>
          <DialogHeader>
            <DialogDescription className="flex flex-col items-center gap-2 pt-6">
              <WarningIcon size={30} className="text-default-red" />
              <div className="text-default-text text-lg font-medium">Unable to load</div>
              <div className="text-default-text text-sm font-normal">An error has occurred with loading issues.</div>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mb-6 flex items-center sm:flex-col sm:space-x-0">
            <Button
              className="bg-default-blue mt-4 w-fit rounded-md p-2.5 text-sm font-medium"
              onClick={() => {
                location.reload();
              }}>
              Retry
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
